import { render, staticRenderFns } from "./PRO_ModSummary.vue?vue&type=template&id=2616ae9a&scoped=true&"
import script from "./PRO_ModSummary.vue?vue&type=script&lang=js&"
export * from "./PRO_ModSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2616ae9a",
  null
  
)

export default component.exports